import React from 'react';
import ReactHOC from "../../../common/react-hoc";
import { resolveImageSrc } from '@demant/wdh';

class ColorSpotApp extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      currentItemIndex: 0,
    };

    this.items = this.props.settings.items;
    this.isIE = window.document.documentMode;
  }

  handleItemClick(e, index) {
    e.preventDefault();
    if (index !== this.state.currentItemIndex) {
      this.setState({currentItemIndex: index});
    }
  }

  handleItemKeyPress(e, index) {
    if (e.keyCode === 13) {
      this.handleItemClick(index);
    }
  }

  getColors(colors) {
    if (this.isIE) {
      return {}
    }
    if (colors.length > 1) {
      return {
        borderColor: colors[0],
        background: `linear-gradient( -45deg, ${colors[1]}, ${colors[1]} 50%, ${colors[0]} 51% )`
      }
    } else {
      return { backgroundColor: colors[0] }
    }
  }



  render() {
    const { currentItemIndex } = this.state;
    const currentItem = this.items[currentItemIndex];
    const imgSrc = currentItem.image.image ? resolveImageSrc(currentItem.image.image) : '';
    return (
      <>
        <div className="current-color">
          <img
            className="current-color__image"
            src={imgSrc}
            alt={currentItem.image.alt}
            width={currentItem.image.width}
            height={currentItem.image.height}
          />
          <p className="current-color__name">{currentItem.name}</p>
        </div>
        <div className="color-picker">
          {this.items.map((item, index) => {
            return (
              <button
                key={index}
                name={item.name}
                onClick={(e) => this.handleItemClick(e, index)}
                onKeyDown={(e) => { this.handleItemKeyPress(e, index) }}
                className={`${index === currentItemIndex ? 'current' : ''} ${item.colors.length > 1 ? 'multicolor' : ''} ${this.isIE ? 'ie' : ''}`}
                style={this.getColors(item.colors)}
              >
                {item.name}
              </button>
            )
          })}
        </div>
      </>
    )
  }
}

export default ReactHOC(ColorSpotApp);
